(function() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  var trident = ua.indexOf('Trident/');
  var edge = ua.indexOf('Edge/');
  var version = false;

  if (msie > 0) version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  else if (trident > 0) { var rv = ua.indexOf('rv:'); version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10); }
  else if (edge > 0) version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);

  if (version) document.body.classList.add('ie-browser');
})();
